export enum localStorageKey {
    AppLanguage = 'app_language',
    MinecraftHead = 'minecraft_head',
    Theme = 'theme',
    AccessToken = 'access_token',
    RefreshToken = 'refresh_token'
}